/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum DeviceHealthErrorCode {
  NonReportingUnit = 'nonReportingUnit',
  FalseTowing = 'falseTowing',
  NoMessage = 'noMessage',
  SDCardError = 'sDCardError',
  VideosNotAvailable = 'videosNotAvailable',
  IncompleteInstallation = 'IncompleteInstallation',
  VideoFileIssue = 'VideoFileIssue',
  MediaErrorLastWeek = 'MediaErrorLastWeek',
  MediaErrorYesterday = 'MediaErrorYesterday',
  TiltedGsensor = 'TiltedGsensor',
  NoMsgFromCam = 'NoMsgFromCam',
  HighTowingFrequency = 'HighTowingFrequency',
  RoadCameraVerticallyMisaligned = 'RoadCameraVerticallyMisaligned',
  MediaErrorYesterdayDvr = 'MediaErrorYesterdayDvr',
  NomsgFromDvr = 'NomsgFromDvr'
}

export enum DeviceHealthIssueCategory {
  Critical = 'CRITICAL',
  Major = 'MAJOR',
  Moderate = 'MODERATE',
  Optimal = 'OPTIMAL'
}

export const DeviceHealthIssueCategories = [
  DeviceHealthIssueCategory.Critical,
  DeviceHealthIssueCategory.Major,
  DeviceHealthIssueCategory.Moderate
];
